import React, { useEffect } from "react";
import ContentLeft from "../../components/ContentLeft";
import ContentRight from "../../components/ContentRight";
import { partnerData } from "../../page-content/partnerContent";
import { partnerDataTwo } from "../../page-content/partnerContentTwo";
import PageHeaderSmall from "../../components/PageHeaderSmall";

const Partners = () => {
  const title = "Our Partners";
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <PageHeaderSmall title={title} />
      <section className="section-wrapper"></section>
      <ContentLeft data={partnerData} />
      <ContentRight data={partnerData} />
      <ContentLeft data={partnerDataTwo} />
      <ContentRight data={partnerDataTwo} />
    </>
  );
};

export default Partners;
